import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { Bot, Cpu, Network, Settings } from 'lucide-react';
export function CreateAgents() {
  return <FeaturePageLayout hero={{
    badge: 'Step 5 of 7',
    h1: <>
            Create & Implement{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal to-purple" data-id="element-1538">
              Agents
            </span>
          </>,
    subtitle: 'We deploy specialized AI agents across your organization, custom-built to handle specific roles with precision and autonomy.'
  }} problem={{
    subtitle: 'The Execution Gap',
    cards: [{
      icon: <Cpu className="w-6 h-6 text-teal" data-id="element-1539" />,
      title: 'Generalist AI Fails',
      desc: 'Trying to use one single AI model to do everything results in mediocre performance across the board.'
    }, {
      icon: <Network className="w-6 h-6 text-purple" data-id="element-1540" />,
      title: 'Integration Nightmares',
      desc: 'Getting AI to actually trigger workflows and talk to your existing software is highly complex.'
    }, {
      icon: <Settings className="w-6 h-6 text-blue-400" data-id="element-1541" />,
      title: 'Lack of Autonomy',
      desc: 'Most AI tools still require constant human prompting and hand-holding to get work done.'
    }]
  }} solution={{
    badge: 'The Deployment',
    title: 'Your Autonomous Workforce',
    desc: 'We build a network of specialized, role-specific agents that communicate with each other and execute tasks autonomously.',
    features: [{
      icon: <Bot className="w-6 h-6 text-teal" data-id="element-1542" />,
      title: 'Role-Specific Agents',
      desc: 'From customer service to internal project management, each agent has a defined job and skill set.'
    }, {
      icon: <Network className="w-6 h-6 text-purple" data-id="element-1543" />,
      title: 'Seamless Integration',
      desc: 'Agents are connected directly to your CRM, email, and internal tools to execute real work.'
    }]
  }} data-id="element-1537" />;
}